module.exports = __webpack_public_path__ + "static/media/camera-arrow.5ef19b2d.svg";